import React, { useEffect, useState } from "react";
import { Select, MenuItem, Box, TextField } from "@mui/material";
import apiClient from "../../../utils/apiClient";
import { showSuccessToast, showErrorToast } from "../../../utils/swalToast";
import DashboardTitleComponent from "../../custom/DashboardTitleComponent";
import CustomDataGrid from "../../custom/CustomDataGrid";

const UserAccessRoleMenu = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [search, setSearch] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient
      .get("/access-control/roles")
      .then((response) => setRoles(response.data.data || []))
      .catch((error) => console.error("Error fetching access roles", error));
  }, []);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      apiClient
        .get("/access-control/users", { params: { search } })
        .then((response) => setUsers(response.data.data || []))
        .catch((error) => console.error("Error fetching users", error))
        .finally(() => setLoading(false));
    }, 300);
    return () => clearTimeout(timeout);
  }, [search, refresh]);

  const handleRoleChange = async (userUuid, accessRoleId) => {
    try {
      await apiClient.put("/access-control/users/role", { userUuid, accessRoleId });
      showSuccessToast("Role user berhasil diperbaharui");
      setRefresh((prev) => !prev);
    } catch (error) {
      showErrorToast(error?.response?.data?.msg || "Terjadi kesalahan");
    }
  };

  return (
    <div>
      <DashboardTitleComponent text={"Role Pengguna"} />
      <Box sx={{ mb: 2 }}>
        <TextField
          label="Cari nama / email"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Box>
      <CustomDataGrid
        rows={users.map((user, index) => ({ id: index + 1, ...user }))}
        loading={loading}
        columns={[
          { field: "nama_lengkap", headerName: "Nama", flex: 1 },
          { field: "email", headerName: "Email", flex: 1 },
          { field: "role", headerName: "Kategori Keanggotaan", flex: 1 },
          {
            field: "access_role_id",
            headerName: "Role Akses",
            flex: 1,
            renderCell: (params) => (
              <Select
                size="small"
                fullWidth
                value={params.row.access_role_id || ""}
                onChange={(e) => handleRoleChange(params.row.uuid, e.target.value)}
              >
                {roles.map((role) => (
                  <MenuItem key={role.id} value={role.id}>
                    {role.name}
                  </MenuItem>
                ))}
              </Select>
            ),
          },
        ]}
      />
    </div>
  );
};

export default UserAccessRoleMenu;
